import HeaderList from "../../components/HeaderList"
import { PageProps } from '../../components/types'
import DataGrid, { FormatterProps } from 'react-data-grid'
import { PicklistStatus, OrderType, ExcelMenus } from '../../constants/EnumType'
import { getColunmPicklist, PicklistWithdrawColumn } from '../../constants/Column'
import { Fragment, useCallback, useMemo, useState } from "react";

import useIssueOrder from "../../hooks/useIssueOrder"

import { DgtPdOrderPicklist } from "../../models"

import { formatNumberV2, formatDateObject } from '../../utilities/Format'
import { RiFileExcel2Line } from 'react-icons/ri'
import GenerateExcelFragranceModal from "../../components/GenerateExcel/fragrance"
import GenerateExcelFGModal from "../../components/GenerateExcel/fg"

import { Menu, Transition } from '@headlessui/react'
import { MdArrowDropDown } from 'react-icons/md'



const GoodIssueOrder = ({ title, division, from, to, orderType }: PageProps) => {
  const [statuses, setStatuses] = useState<string[]>([ PicklistStatus.PD_REQUESTED ])
  const [dateRange, setDateRange] = useState<[Date, Date]>([from || new Date(), to || new Date()]);
  const [keyword, setKeyword] = useState<string>('')
  const [div, setDiv] = useState<string>(division!)
  const [ showFragranceDialog, setShowFragranceDialog ] = useState<boolean>(false)
  const [ showOrderListDialog, setShowOrderListDialog ] = useState<boolean>(false)

  const picklists = useIssueOrder(statuses[0], orderType || '', dateRange[0], dateRange[1], keyword, div)

  const filterChanged = useCallback((
    key: string, value: string, dateRange?: [Date, Date], values?: string[]) => {
    switch(key) {
      case 'Status':
        return setStatuses(values!)
      case 'Released Date Range':
        return setDateRange(dateRange!)
      case 'Search':
        return setKeyword(value)
      case 'Division':
        return setDiv(value)
      default:
        break
    }
  }, [])

  const coupleStatuses = useMemo(() => 
    [PicklistStatus.PD_REQUESTED, PicklistStatus.WH_SHORTAGE, PicklistStatus.WH_APPROVED]
  , [])

  let columns = Array.from(getColunmPicklist(PicklistWithdrawColumn))
  columns.splice(columns.length - 1, 1)

  if (statuses[0] === PicklistStatus.WH_SHORTAGE) {
    columns.splice(columns.length - 5, 4, {
      key: 'shortageItems', name: 'รายการ Shortage', width: 560,
      formatter: (props: FormatterProps<DgtPdOrderPicklist>) => {
        const shortageItems: DgtPdOrderPicklist[] = props.row.shortageItems ? JSON.parse(props.row.shortageItems) : []
        return <div className='space-y-2'>
        {shortageItems.map(itm => <p key={itm.materialCode}>&#8226; {itm.materialCode}-{itm.materialDescription} <b>{formatNumberV2(itm.withdrawQty)} / {formatNumberV2(itm.requestQty)} {itm.materialUnit}</b></p>)}
      </div>
      }, cellClass: "multi-line-row-data-grid"
    })
  }

  const allowExportMenus = useMemo(() => {
    if (orderType === 'bulk') return ExcelMenus.bulk
    if (orderType === 'fg') return ExcelMenus.fg
    return []
  }, [ orderType ])

  const clickExport = useCallback((id: number) => {
    if (id === 1) return setShowOrderListDialog(true)
    else if (id === 2) return setShowFragranceDialog(true)
  }, [])

  return <div className="page-container">
    <HeaderList title={title} subTitle={`แผนก : ${division}`}
      orderType={OrderType.All}
      filterType={false}
      statuses={statuses}
      dateRange={dateRange}
      keywordSearch={keyword}
      coupleStatuses={coupleStatuses}
      filterChanged={filterChanged}
      division={div}
    />
    <div className="flex justify-between my-2">
      <div className="flex gap-3">
        <div className="flex items-center gap-1 italic ">
          <div className="w-5 h-2 bg-yellow-300"></div>
          <small>PD ขอมาแล้ว 4 วัน</small>
        </div>
        <div className="flex items-center gap-1 italic ">
          <div className="w-5 h-2 bg-red-300"></div>
          <small>PD ขอมาแล้ว 6 วัน</small>
        </div>
      </div>
      {allowExportMenus.length > 0 ? <div>
        <Menu as="div" className="relative inline-block text-left" >
          <div>
            <Menu.Button
              className={` btn-outline-success inline-flex justify-center gap-1`}>
              <RiFileExcel2Line size={20} />
              Export
              <MdArrowDropDown size={20}/>
            </Menu.Button>
          </div>
          <Transition
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items className="absolute right-0 z-10 w-48 mt-2 origin-top-right bg-white divide-y divide-gray-100 rounded-md shadow-lg ring-1 ring-black/5 focus:outline-none">
              <div className="px-1 py-1 ">
                {allowExportMenus.map(m => <Menu.Item key={m.title}>
                  {() => (
                    <button
                      className={`flex p-2 hover:font-bold items-center gap-3 w-full hover:bg-gray-300 ${m.className}`}
                      onClick={() => clickExport(m.id)}>
                      {<m.icon size={20} />}{m.title}
                    </button>
                  )}
                </Menu.Item>)}
              </div>
            </Menu.Items>
          </Transition>
        </Menu>
      </div>
      : null}
    </div>
    <DataGrid style={{ height: "100%", contain: "none" }}
      columns={columns}
      rows={picklists}
      defaultColumnOptions={{ resizable: true }}
      rowHeight={row => {
        const rowPicklist = row.row as DgtPdOrderPicklist
        const items = rowPicklist && rowPicklist.shortageItems ? JSON.parse(rowPicklist.shortageItems) : []
        if (items <= 1 || rowPicklist.status !== PicklistStatus.WH_SHORTAGE) return 60
        return items.length * 35
      }}
    />
    {showFragranceDialog && <GenerateExcelFragranceModal
      show={showFragranceDialog} 
      onClose={() => setShowFragranceDialog(false)}
      bulkOrders={picklists}
      filename={`${div}_${statuses[0]}_${formatDateObject(dateRange[0])}_${formatDateObject(dateRange[1])}`}
    />
    }
    {showOrderListDialog && <GenerateExcelFGModal
      show={showOrderListDialog} 
      onClose={() => setShowOrderListDialog(false)}
      status={statuses[0]}
      divison={div}
      dateRange={`${formatDateObject(dateRange[0], 'dd.MM.yyyy')} - ${formatDateObject(dateRange[1], 'dd.MM.yyyy')}`}
      fgOrders={picklists}
      filename={`${div}_${statuses[0]}_${formatDateObject(dateRange[0])}_${formatDateObject(dateRange[1])}`}
    />
    }
  </div>
}

export default GoodIssueOrder